import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { ProductMapper } from "../../../Lib/Mapper/ProductMapper";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { IAddToCartRequest } from "../../../Models/Tickets/IAddToCartRequest";
import { AxProdInitData, PreDateable } from "../Abstraction/PreDateable";
import { Translations } from "../../../Lib/Helper/I18nHelper";

@ModuleName("AxProdPredateable")
export class AxProdPredateable extends PreDateable implements AxInit {
    private ProjNr: number;
    private PoolNr: number;
    private TicketTypeNr: number;


    constructor(private _ProductMapper = new ProductMapper(),
        private _AxLimestone = new AxLimeStone()) {
        super();
    }

    AxInit(initData: AxProdInitData): void {
        this.ProjNr = initData.ProjNr;
        this.PoolNr = initData.ProductGroupIdentifier;
        this.TicketTypeNr = initData.Id;

        this.Init(initData);

        $('.prod_selection__persontype-submit').click(e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.CheckSelectedDate();
        });
    }

    CheckSelectedDate() {
        const currentDate = new Date();
        const momentInstance = moment(currentDate);
        if (this.ActivateDate.format('YYYY-MM-DD') < momentInstance.format('YYYY-MM-DD')) {
            Swal.fire({
                title: this._I18nHelper.GetTranslation(Translations.WrongDay),
                text: this._I18nHelper.GetTranslation(Translations.WrongSelectedDay),
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: this._I18nHelper.GetTranslation(Translations.AdminClose)
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
        else {
            this.ToSummary();
        }
    }

    ToSummary(): void {
        if (this.CheckSubmit()) {
            let requestObj: IAddToCartRequest = {
                Date: this.ActivateDate.format('YYYY-MM-DD'),
                ProjNr: this.ProjNr,
                PoolNr: this.PoolNr,
                TicketTypeId: this.TicketTypeNr,
                PersonTypes: this._ProductMapper.GetPersonTypeList(this._TicketList.ProductList),
            };
            this._summaryRedirect.redirect(this.PostURL, requestObj, false);
        }

    }
}
